import React, { ReactElement, useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { getIn, FormikProps } from 'formik';

type CheckboxFieldInput = {
  formikProps: FormikProps<any>
  fieldName: string,
  visibleName: string,
  extraClassValues?: string,
  formText?: string,
  onChangeCallback?:
    (val: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>)=>void,
}
const CheckboxField: React.FC<CheckboxFieldInput> = (
  props: CheckboxFieldInput,
): ReactElement => {
  const {
    fieldName,
    visibleName,
    extraClassValues = '',
    formText = '',
    onChangeCallback,
    formikProps,
  } = props;

  const {
    handleBlur,
    values,
    touched,
    errors,
    setFieldValue,
  } = formikProps;

  const [checked, setChecked] = useState(!!getIn(values, fieldName));

  useEffect(() => {
    if (checked !== !!getIn(values, fieldName)) {
      setFieldValue(fieldName, checked);
    }
  }, [checked, fieldName, values]);

  return (
    <Form.Group controlId={fieldName} className={`checkbox-field ${extraClassValues}`}>
      <Form.Label>{visibleName}</Form.Label>
      <Form.Check
        name={visibleName}
        checked={checked}
        onChange={(e) => {
          setChecked(!checked);
          if (onChangeCallback) {
            onChangeCallback(e);
          }
        }}
        onBlur={handleBlur}
        isInvalid={getIn(touched, fieldName) && getIn(errors, fieldName)}
      />
      <Form.Text className="text-muted">
        {formText}
      </Form.Text>
      <Form.Control.Feedback type="invalid">
        {getIn(errors, fieldName)}
      </Form.Control.Feedback>
    </Form.Group>
  );
};
export default CheckboxField;
